import style from './video2CompoStyle.module.css';
import { useRef, useState } from 'react';
import { createStyles } from '@mantine/core';
import { Link } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css';
const useStyle = createStyles((theme) => ({
  cards: {
    backgroundColor: 'transparent!important',
    border: 'none',
    width: '100%',
    maxWidth: 350,
    '@media (max-width: 600px)': {
      padding: 0,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: '100%',
      border: 'none',
      maxWidth: 326,
      background:
        'linear-gradient(to bottom, rgba(255, 255, 255, 0.20), rgba(10, 10, 10, 0.50))',
      zIndex: 0,
      borderRadius: '30px',
      '@media (min-width: 1200px) and (max-height: 500px)': {
        width: '85%',
      },
    },
  },
  cio: {
    height: '100%',
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
  },
  textWrapper: {
    padding: 16,
  },
  video: {
    borderRadius: '30px',
    boxShadow: '10px 10px 5px 0px rgb(0 0 0 / 10%)',
    '@media (max-width: 600px)': {
      borderRadius: 0,
    },
  },
  cardTitle: {
    paddingLeft: '5%',
    fontWeight: 700,
    fontSize: 18,
  },
  iconTextWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20%',
    alignItems: 'center',
    padding: '5%',
  },
  cardText: {
    width: 300,
    fontWeight: 400,
    fontSize: 16,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxLines: '3!important',
    height: 80,
    webkitBox: {
      webkitLineClamp: 2 /* number of lines to show */,
      lineClamp: 2,
      webkitBoxOrient: 'vertical',
    },
    '@media (max-width: 600px)': {
      textOverflow: 'ellipsis!important',
    },
  },
  iconText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  iconTextImg: {
    width: 40,
    height: 38,
  },
  result: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontSize: 20,
    fontWeight: 700,
    color: '#fefefd',
  },
  gridCol: {
    '@media (max-width: 600px)': {
      padding: 50.5,
      paddingBottom: 0,
    },
  },
  btnExpand: {
    '@media (max-width: 600px)': {
      marginTop: 100,
    },
  },
}));
const VideoCompo = (props) => {
  const { classes } = useStyle();
  const [activeElement, setActiveElement] = useState('');
  // useEffect(() => {
  //   Aos.init({
  //     duration: 300,
  //     easing: 'ease-in-sine',
  //     offset: 200,
  //     delay: 100,
  //   });
  // }, []);
  // Function Video Section
  function play(video) {
    const vid = document.getElementById(video);
    if (vid.paused) {
      setActiveElement(style.active);
      vid.play();
    } else {
      setActiveElement(style['not-active']);
      vid.pause();
    }
  }
  const listElement = useRef(null);
  function apper() {
    listElement.current.classList.add(style.actived);
    listElement.current.classList.remove(style['not-actived']);
  }
  function dissaper() {
    listElement.current.classList.add(style['not-actived']);
    listElement.current.classList.remove(style.actived);
  }
  return (
    <>
      <div className={`card text-bg-dark ${classes.cards} ${style.cards}`}>
        <video
          id={props.myId}
          className={classes.video}
          src={props.video}
        ></video>
        <div className={`card-img-overlay ${classes.cio}`}>
          <div className={classes.textWrapper}>
            <h1 className={`card-title ${classes.cardTitle}`}>{props.title}</h1>
            <div className={`iconText-wrapper ${classes.iconTextWrapper}`}>
              <p className={`card-text ${classes.cardText} ${classes.p}`}>
                {props.desc}
              </p>
              <div className={`iconText ${classes.iconText}`}>
                <img
                  src={require('../../assets/images/iconFavorite.png')}
                  alt=""
                  className={classes.iconTextImg}
                />
                <p className={classes.result}>{props.likes}</p>
              </div>
            </div>
          </div>
          <span
            className={style['tmb-selengkapnya-wrapper']}
            onMouseOver={() => apper(this)}
            onMouseOut={() => dissaper(this)}
            ref={listElement}
          >
            <Link
              to={`/detail-artikel?id=${props.myId}`}
              className={`btn btn-success ${style.btnInfo}`}
            >
              Baca Selengkapnya
            </Link>
          </span>
        </div>
        <span className={`${style['tmb-play-wrapper']} `}>
          <button
            className={`${style.playbtn} ${activeElement}`}
            onClick={() => play(props.myId)}
          >
            <img src={require('../../assets/images/play.png')} alt="" />
          </button>
        </span>
      </div>
    </>
  );
};

VideoCompo.defaultProps = {
  video: 'No Video',
  title: 'Title',
  desc: 'Description...',
};
export default VideoCompo;
